import { store } from '../../store';
import { activeSpeakersSelector, addSpeaker, removeSpeakers, setAllSpeakers, } from '../../store/slices/activeSpeakersSlice';
const ACTIVE_SPEAKER_LIST_CHANGE_DURATION = 1000; // milliseconds
const ACTIVE_SPEAKER_VIDEO_REARRANGE_DURATION = 4000; // milliseconds
export default class HandleActiveSpeakers {
    constructor(that) {
        this.lastActiveWebcamChanged = Date.now();
        this.activeSpeakers = [];
        this.activeSpeakersChanged = (participants) => {
            this.activeSpeakers = [];
            if (participants.length) {
                const isPaginating = store.getState().session.isWebcamPaginating;
                const now = Date.now();
                participants.forEach((participant) => {
                    var _a, _b, _c;
                    // we won't update if user is paginating & viewing webcams from other pages.
                    if (!isPaginating && this.that.videoSubscribersMap.size > 3) {
                        // we'll wait little bit before changing
                        const last = this.lastActiveWebcamChanged +
                            ACTIVE_SPEAKER_VIDEO_REARRANGE_DURATION;
                        if (now > last) {
                            if (this.that.videoSubscribersMap.has(participant.identity)) {
                                this.that.updateVideoSubscribers(participant);
                                this.lastActiveWebcamChanged = now;
                            }
                        }
                    }
                    const speaker = {
                        sid: participant.sid,
                        userId: participant.identity,
                        metadata: participant.metadata,
                        name: (_a = participant === null || participant === void 0 ? void 0 : participant.name) !== null && _a !== void 0 ? _a : '',
                        isSpeaking: participant.isSpeaking,
                        audioLevel: participant.audioLevel,
                        lastSpokeAt: (_c = (_b = participant.lastSpokeAt) === null || _b === void 0 ? void 0 : _b.getTime()) !== null && _c !== void 0 ? _c : Date.now(),
                    };
                    store.dispatch(addSpeaker(speaker));
                    this.activeSpeakers.push(speaker);
                });
            }
        };
        this.runInterval = () => {
            this.interval = setInterval(() => {
                if (!this.activeSpeakers.length) {
                    const speakers = activeSpeakersSelector.selectAll(store.getState());
                    if (speakers.length) {
                        store.dispatch(removeSpeakers());
                    }
                }
                else {
                    store.dispatch(setAllSpeakers(this.activeSpeakers));
                }
            }, ACTIVE_SPEAKER_LIST_CHANGE_DURATION);
        };
        this.onLivekitDisconnect = () => {
            clearInterval(this.interval);
        };
        this.that = that;
        this.runInterval();
    }
}
